function initUpsellCarousel(section) {
  if (typeof EmblaCarousel === "undefined") {
    return;
  }

  const root = section.querySelector("[data-product-carousel]");
  const viewport = root ? root.querySelector(".embla__viewport") : null;

  if (!viewport) {
    return;
  }

  const slideCount = viewport.querySelectorAll(".embla__slide").length;
  if (slideCount === 0) {
    return;
  }

  const embla = EmblaCarousel(viewport, {
    align: "start",
    containScroll: "trimSnaps",
  });

  const prevButton = section.querySelector(".carousel-prev");
  const nextButton = section.querySelector(".carousel-next");

  const updateButtons = () => {
    prevButton?.classList.toggle("is-disabled", !embla.canScrollPrev());
    nextButton?.classList.toggle("is-disabled", !embla.canScrollNext());
  };

  prevButton?.addEventListener("click", () => embla.scrollPrev());
  nextButton?.addEventListener("click", () => embla.scrollNext());

  embla.on("select", updateButtons);
  embla.on("reInit", updateButtons);
  updateButtons();
}

document.addEventListener("product-recommendations:loaded", (event) => {
  initUpsellCarousel(event.target);
});
